import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from '@cotyorg/ccx-atoms/Select';
import Button from '@cotyorg/ccx-atoms/Button';

const ShoppableBuyButton = ({
  product,
  variation,
  buttonText,
  selectLabelText,
}) => {
  const [quantity, setQuantity] = useState(1);

  const selectOptions = Array.from({ length: 12 }, (_, index) => {
    const value = index + 1;
    return {
      name: `${value}`,
      value,
      isSelected: value === quantity,
    };
  });

  const handleAddToShoppableCart = () => {
    if (typeof window.addToShoppableCart === 'function') {
      const mappedProduct = {
        name: `${product.name} - ${product.shadeName}`,
        upc: product.ean,
        quantity,
      };

      console.log('mappedProduct', mappedProduct); // temporarily for testing purposes

      window.addToShoppableCart({
        products: [mappedProduct],
        variation,
      });
      const iframe = document.getElementById('shoppable-cart-frame');
      iframe.focus();
      iframe.title = 'Shopping cart';
    } else {
      console.error('window.addToShoppableCart is not defined');
    }
  };

  return (
    <div className="grid-x">
      <div className="cell xsmall-16 small-8">
        <div className="product-selection__quantity">
          <label
            className="product-selection__quantity__label"
            htmlFor="shoppable-qty"
          >
            {selectLabelText}
            :
            <Select
              id="shoppable-qty"
              chevronIconSrc="/ccx-files/assets/chevron-down.svg"
              selectOptions={selectOptions}
              onChange={(value) => setQuantity(parseInt(value, 10))}
            />
          </label>
        </div>
      </div>

      <div className="cell xsmall-16 small-8">
        <Button
          testAttribute="add-to-basket-button"
          theme="primary"
          size="large"
          extraClass="product-selection__button"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleAddToShoppableCart();
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

// PropTypes validation
ShoppableBuyButton.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    shadeName: PropTypes.string,
    ean: PropTypes.string,
    sku: PropTypes.string,
  }).isRequired,
  variation: PropTypes.bool.isRequired, // Variation is required and must be a boolean
  buttonText: PropTypes.string.isRequired,
  selectLabelText: PropTypes.string.isRequired,
};

export default ShoppableBuyButton;
